import { render, staticRenderFns } from "./City.vue?vue&type=template&id=23010b4e&scoped=true"
import script from "./City.vue?vue&type=script&lang=js"
export * from "./City.vue?vue&type=script&lang=js"
import style0 from "./City.vue?vue&type=style&index=0&id=23010b4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23010b4e",
  null
  
)

export default component.exports